export default "__VITE_ASSET__84981cbe__"